import {
  AfterViewInit,
  Component,
  ViewChild,
  ViewContainerRef
} from "@angular/core";

import { ICellEditorAngularComp, AgRendererComponent } from "ag-grid-angular";
import * as moment from "moment";
import { ICellRendererParams } from "ag-grid/dist/lib/rendering/cellRenderers/iCellRenderer";
import { IAfterGuiAttachedParams } from "ag-grid/dist/lib/interfaces/iComponent";

@Component({
  selector: "date-editor-cell",
  template: `
    <ixs-date
      #input
      (change)="valueChange(data)"
      [(ngModel)]="value"
    ></ixs-date>
  `,
  styles: ["border:none;"]
})
export class GridDatePickerComponent implements AgRendererComponent {
  refresh(params: any): boolean {
    return true;
  }
  async agInit(params: ICellRendererParams) {
    const element = this.input.element.nativeElement.children[1];
    if (element) {
      element.style.marginTop = "-26px";
      element.children[0].classList.remove("form-control");
      element.children[0].style.border = "none";
    }
    this.params = params;
    this.input.disabled = !Boolean(
      this.params.colDef.editable === undefined
        ? true
        : this.params.colDef.editable
    );
    this.value = this.params.value;

    const element1: HTMLElement = this.input.element.nativeElement;
    if (element1) {
      element1.getElementsByTagName("input")[0].style.backgroundColor =
        "transparent";
    }
    setTimeout(async () => {
      if (this.params && this.params.colDef && this.params.colDef.focus && this.params.colDef.focus === true) {
       await this.setDateControlFocus();
      }
    }, 0);
  }
  afterGuiAttached(params?: IAfterGuiAttachedParams): void {}
  private params: any;
  public value: any;
  private cancelBeforeStart: boolean = false;

  @ViewChild("input") public input;

  getValue(): any {
    return this.params.value;
  }

  valueChange(data) {
    this.params.setValue(this.value);
  }

  public async setDateControlFocus(){
    if(this.input && this.input.element && this.input.element.nativeElement && this.input.element.nativeElement.children){
      this.input.element.nativeElement.children[1].children[0].focus();
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/components/grid/editors/date/datecomponent.ts